var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedJobs = function SvgLinkedJobs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.68 9.994q0-.703.785-.703H7.6q.504 0 1.072-.264a6 6 0 0 0 1.119-.685 7.7 7.7 0 0 0 1.008-.897q.457-.48.738-.92l.31-.48a.68.68 0 0 1 .61-.34q.276 0 .48.176.206.175.206.51 0 .298-.182.574l-.2.304q-.269.405-.661.832a10 10 0 0 1-.832.815q-.446.386-.885.668-.44.28-.809.398v.024q.37.117.809.398.44.287.885.668.445.387.832.814.392.429.662.838l.199.305q.182.276.182.568 0 .335-.2.51a.7.7 0 0 1-.486.182.68.68 0 0 1-.61-.346l-.31-.48a6.5 6.5 0 0 0-.738-.926q-.451-.48-1.008-.897a6 6 0 0 0-1.12-.68q-.567-.257-1.071-.257H4.465q-.785 0-.785-.71m7.136-4.266q-.3-.234-.21-.498.087-.258.468-.369l2.537-.732q.305-.094.51.064.21.165.2.48l-.094 2.643q-.012.398-.247.54-.234.146-.533-.083zm.018 8.438 2.695-1.957q.3-.223.528-.07.234.152.234.55l.006 2.643q0 .322-.217.474-.21.153-.51.053l-2.513-.82q-.376-.117-.457-.387-.077-.27.234-.486"
  })));
};
export default SvgLinkedJobs;